<script>
// import axios from "axios";

import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
// import { mapState, mapGetters } from "vuex";

import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
import axios from "axios";
/**
 * Login component
 */

export default {
  page: {
    title: "Inicio de sesión",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {},
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      email: "",
      password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
    };
  },
  validations: {
    email: {
      required,
    },
    password: {
      required,
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),

    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    async tryToLogIn() {
      const { email, password } = this;
      await this.login({ email, password });
      // location.reload();
    },
    onValidate() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.tryToLogIn();
      }
    },
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    // console.log(usuario);
    if (usuario === "" || usuario === null || usuario === "null" || usuario.token === undefined) {
      this.logout();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: {
          "x-token":  usuario.token,
        },
      })
        .then((res) => {
          if (res.data.success) {
            this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
        });
    }
  },
};
</script>

<template>
  <div class="auth">
    <!-- ===== Panel de marca ===== -->
    <aside class="auth-brand">
      <div class="auth-brand__top">
        <span class="auth-logo">
          <img src="/logo.jpeg" alt="Taller Ariel" />
        </span>
        <h1 class="auth-brand__title">Sistema de Gestión<br />Integral</h1>
        <p class="auth-brand__sub">Taller Ariel · Lubricantes y Repuestos</p>
        <ul class="auth-feat">
          <li>
            <span class="auth-feat__dot"><i class="bx bx-check"></i></span>
            Ventas, compras e inventario
          </li>
          <li>
            <span class="auth-feat__dot"><i class="bx bx-check"></i></span>
            Taller y órdenes de servicio
          </li>
          <li>
            <span class="auth-feat__dot"><i class="bx bx-check"></i></span>
            Caja, créditos y reportes
          </li>
        </ul>
      </div>
      <div class="auth-brand__foot">
        © {{ new Date().getFullYear() }} Lubricantes y Repuestos Ariel
      </div>
    </aside>

    <!-- ===== Panel de formulario ===== -->
    <main class="auth-form">
      <div class="auth-form__wrap">
        <h2 class="auth-form__hi">Bienvenido</h2>
        <p class="auth-form__sub">
          Ingresa tus credenciales para acceder al sistema
        </p>

        <b-alert
          v-model="isAuthError"
          variant="danger"
          class="mb-3"
          dismissible
          >{{ authError }}</b-alert
        >
        <div
          v-if="notification.message"
          :class="'alert ' + notification.type"
        >
          {{ notification.message }}
        </div>

        <b-form @submit.prevent="onValidate">
          <!-- Usuario -->
          <div class="auth-field">
            <label for="input-1">Usuario</label>
            <div class="auth-ctrl">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="12" cy="8" r="4" />
                <path d="M4 21c0-4 4-6 8-6s8 2 8 6" />
              </svg>
              <b-form-input
                id="input-1"
                v-model="email"
                type="text"
                placeholder="Ingrese el usuario"
                :class="{ 'is-invalid': submitted && $v.email.$error }"
              ></b-form-input>
              <div
                v-if="submitted && $v.email.$error"
                class="invalid-feedback d-block"
              >
                <span v-if="!$v.email.required">El usuario es necesario.</span>
              </div>
            </div>
          </div>

          <!-- Contraseña -->
          <div class="auth-field">
            <label for="input-2">Contraseña</label>
            <div class="auth-ctrl">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect x="4" y="10" width="16" height="11" rx="2" />
                <path d="M8 10V7a4 4 0 0 1 8 0v3" />
              </svg>
              <b-form-input
                id="input-2"
                v-model="password"
                type="password"
                placeholder="Ingrese la contraseña"
                :class="{ 'is-invalid': submitted && $v.password.$error }"
              ></b-form-input>
              <div
                v-if="submitted && !$v.password.required"
                class="invalid-feedback d-block"
              >
                La contraseña es necesaria.
              </div>
            </div>
          </div>

          <button type="submit" class="auth-submit">Iniciar Sesión</button>
        </b-form>

        <p class="auth-copy">
          © {{ new Date().getFullYear() }} Taller Ariel · Innovación Continua.
          Todos los derechos reservados.
        </p>
      </div>
    </main>
  </div>
</template>

<style scoped>
.auth {
  display: flex;
  min-height: 100vh;
  background: #fff;
}

/* ===== Panel de marca ===== */
.auth-brand {
  position: relative;
  flex: 0 0 46%;
  max-width: 46%;
  padding: 56px 52px;
  color: #fff;
  overflow: hidden;
  background: radial-gradient(
      1100px 520px at 80% -10%,
      rgba(43, 125, 225, 0.55),
      transparent 60%
    ),
    linear-gradient(150deg, #0a1a33 0%, #0d3a78 55%, #1b6ec2 120%);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
/* arco de velocímetro (eco del logo) */
.auth-brand::before {
  content: "";
  position: absolute;
  top: -150px;
  right: -150px;
  width: 440px;
  height: 440px;
  border-radius: 50%;
  background: conic-gradient(
    from 200deg,
    #34c38f,
    #f1b44c,
    #f1734f,
    #f46a6a 120deg,
    transparent 120deg
  );
  -webkit-mask: radial-gradient(
    circle,
    transparent 58%,
    #000 59%,
    #000 72%,
    transparent 73%
  );
  mask: radial-gradient(
    circle,
    transparent 58%,
    #000 59%,
    #000 72%,
    transparent 73%
  );
  opacity: 0.2;
}
.auth-brand__top {
  position: relative;
  z-index: 1;
}
/* logo "flotante": halo blanco + máscara radial para fundir el fondo del JPEG */
.auth-logo {
  position: relative;
  display: inline-flex;
  padding: 26px;
}
.auth-logo::before {
  content: "";
  position: absolute;
  inset: -4px;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.9),
    rgba(255, 255, 255, 0) 64%
  );
}
.auth-logo img {
  position: relative;
  width: 236px;
  display: block;
  -webkit-mask: radial-gradient(
    circle at 50% 50%,
    #000 50%,
    transparent 71%
  );
  mask: radial-gradient(circle at 50% 50%, #000 50%, transparent 71%);
}
.auth-brand__title {
  color: #ffffff; /* el template da color oscuro a los <h1>; lo forzamos a blanco */
  font-size: 2.3rem;
  font-weight: 700;
  line-height: 1.12;
  margin: 28px 0 6px;
  text-shadow: 0 2px 14px rgba(0, 0, 0, 0.22);
}
.auth-brand__sub {
  opacity: 0.82;
  font-size: 1.02rem;
  margin: 0 0 30px;
}
.auth-feat {
  list-style: none;
  padding: 0;
  margin: 0;
}
.auth-feat li {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
  font-size: 1rem;
  opacity: 0.95;
}
.auth-feat__dot {
  flex: 0 0 34px;
  height: 34px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: rgba(255, 255, 255, 0.12);
  color: #9ed0ff;
  font-size: 1.1rem;
}
.auth-brand__foot {
  position: relative;
  z-index: 1;
  opacity: 0.7;
  font-size: 0.82rem;
}

/* ===== Panel de formulario ===== */
.auth-form {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 28px;
}
.auth-form__wrap {
  width: 100%;
  max-width: 400px;
}
.auth-form__hi {
  font-size: 1.7rem;
  font-weight: 700;
  color: #0b1e3a;
  margin: 0;
}
.auth-form__sub {
  color: #6b7b8f;
  margin: 0.35rem 0 1.8rem;
}
.auth-field {
  margin-bottom: 1.05rem;
}
.auth-field label {
  display: block;
  font-size: 0.86rem;
  font-weight: 600;
  color: #41506a;
  margin-bottom: 0.4rem;
}
.auth-ctrl {
  position: relative;
}
.auth-ctrl > svg {
  position: absolute;
  left: 14px;
  top: 25px;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  color: #9aa7b8;
  z-index: 2;
  pointer-events: none;
}
.auth-ctrl >>> .form-control,
.auth-ctrl input {
  width: 100%;
  height: 50px;
  border: 1.5px solid #e3e8f0;
  border-radius: 12px;
  padding: 0 16px 0 44px;
  font-size: 0.98rem;
  background: #fbfcfe;
  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
}
.auth-ctrl >>> .form-control:focus,
.auth-ctrl input:focus {
  border-color: #1b6ec2;
  box-shadow: 0 0 0 4px rgba(27, 110, 194, 0.12);
  background: #fff;
}
.auth-ctrl >>> .form-control.is-invalid {
  border-color: #f46a6a;
  background-image: none;
}
.auth-submit {
  width: 100%;
  height: 52px;
  border: 0;
  border-radius: 12px;
  color: #fff;
  font-weight: 600;
  font-size: 1.02rem;
  cursor: pointer;
  background: linear-gradient(135deg, #1b6ec2, #0d4f9e);
  box-shadow: 0 12px 26px rgba(27, 110, 194, 0.32);
  margin-top: 0.4rem;
  transition: filter 0.15s, transform 0.05s;
}
.auth-submit:hover {
  filter: brightness(1.05);
}
.auth-submit:active {
  transform: translateY(1px);
}
.auth-copy {
  margin-top: 2rem;
  text-align: center;
  color: #9aa7b8;
  font-size: 0.76rem;
}

/* ===== Responsive: marca pasa a header compacto arriba ===== */
@media (max-width: 991.98px) {
  .auth {
    flex-direction: column;
  }
  .auth-brand {
    flex: none;
    max-width: 100%;
    padding: 26px 24px 30px;
    align-items: center;
    text-align: center;
  }
  .auth-brand::before {
    width: 230px;
    height: 230px;
    top: -95px;
    right: -70px;
  }
  .auth-logo {
    padding: 8px;
  }
  .auth-logo img {
    width: 168px;
  }
  .auth-brand__title {
    font-size: 1.3rem;
    margin: 6px 0 0;
  }
  .auth-brand__sub,
  .auth-feat,
  .auth-brand__foot {
    display: none;
  }
}
@media (max-width: 575.98px) {
  .auth-form {
    padding: 30px 20px;
  }
}
</style>
